var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ef00ff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,2c-12.69141,0 -23,10.30859 -23,23c0,12.69141 10.30859,23 23,23c12.69141,0 23,-10.30859 23,-23c0,-12.69141 -10.30859,-23 -23,-23zM25,4c11.60938,0 21,9.39063 21,21c0,11.60938 -9.39062,21 -21,21c-11.60937,0 -21,-9.39062 -21,-21c0,-11.60937 9.39063,-21 21,-21zM24.9375,10.78125c-0.14453,0.01953 -0.30078,0.07813 -0.4375,0.15625l-0.90625,0.53125c-0.53906,0.3125 -0.71875,1.02344 -0.40625,1.5625l7.84375,13.5l2.875,-1.6875l-7.84375,-13.5c-0.23437,-0.40234 -0.6875,-0.61719 -1.125,-0.5625zM22.53125,15.28125c-0.4375,-0.05859 -0.89062,0.125 -1.125,0.53125l-1,1.71875l2.96875,1.71875l1,-1.6875c0.31641,-0.53906 0.13281,-1.24609 -0.40625,-1.5625l-1,-0.59375c-0.13672,-0.07812 -0.29297,-0.10547 -0.4375,-0.125zM20.15625,17.9375l-6.90625,11.875l2.9375,1.71875l6.9375,-11.84375zM10.3125,23.3125v3.3125h4.21875l1.9375,-3.3125zM21.4375,23.3125l-1.84375,3.3125h10.75l-1.84375,-3.3125zM33.71875,23.3125l1.78125,3.3125h4.125v-3.3125zM34.21875,25.40625l-2.875,1.65625l1.65625,2.875l2.875,-1.6875zM35.75,29.03125c-0.09766,0.01563 -0.21484,0.07031 -0.3125,0.125c-0.46875,0.26563 -1.15234,0.66016 -1.5625,0.90625c-0.76953,0.46094 -0.17578,1.80078 0,2.09375c0.99609,1.66797 2.00781,1.44531 2.78125,2.625c0.42578,0.64453 0.30469,0.91016 0.4375,1.125c0.05078,0.07813 0.24609,0.18359 0.3125,0.09375c1.19531,-1.65234 0.83203,-4.51562 -0.03125,-5.78125c-0.35156,-0.51562 -0.94922,-1.29687 -1.625,-1.1875zM12.875,30.4375l-1.4375,5.40625c-0.02734,0.09766 0.00781,0.19922 0.09375,0.25c0.08594,0.05078 0.21094,0.03906 0.28125,-0.03125l4,-3.875z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.c40f0b87cc5259899182750398f0591c.svg";
export { ForwardRef as ReactComponent };